import { ProviderExtension } from "../registry";

export const githubExtension: ProviderExtension = {
  labels: {
    webClientIdLabel: "Client ID",
    webClientIdPlaceholder: "Iv1.abcdef0123456789",
  },
};
